// extracted by mini-css-extract-plugin
export default {"Topics":"topics_Topics__I0OCU"};